import React, { ReactNode } from 'react'
import { Select, Form } from 'antd'
import { WrappedFieldProps } from 'redux-form'
import { InputProps } from 'antd/lib/input'
import { FormItemLabelProps } from 'antd/lib/form/FormItemLabel'
import { LoadingOutlined } from '@ant-design/icons'

// assets
import { ReactComponent as ChevronIcon } from '../assets/icons/BaseMiniIcons/chevron-down-3-icon.svg'

const { Item } = Form

const { Option } = Select

type Props = WrappedFieldProps &
	InputProps &
	FormItemLabelProps & {
		label?: string
		placeholder?: string
		required?: boolean
		allowClear?: boolean
		options: any[]
		loading?: boolean
		mode?: 'multiple' | 'tags' | undefined
		clearBtn?: boolean
		maxOptions?: number
		getPopupContainer?: any
		showSearch?: boolean
	}

const SelectField = (props: Props) => {
	const {
		input,
		label,
		placeholder,
		required,
		style,
		className,
		options,
		size,
		disabled,
		meta: { error, touched },
		mode,
		clearBtn,
		loading,
		defaultValue,
		maxOptions,
		getPopupContainer,
		showSearch
	} = props

	const onChange = (value: any, option: any) => {
		if (!value) {
			input.onChange('')
		}
		if (option?.extra) {
			input.onChange({ value, extra: option?.extra })
		} else {
			input.onChange(value)
		}
	}

	const renderOptions = (opt: any) => {
		let contentOpts: ReactNode[] = []
		if (opt && opt.length > 0) {
			contentOpts = opt.map((option: any) => {
				if (option.icon) {
					return (
						<Option key={option.value} value={option.value}>
							{option.icon} {option.label}
						</Option>
					)
				}
				// if you need pass object use extra
				return (
					<Option key={option.value} value={option.value} extra={option?.extra}>
						{option.label}
					</Option>
				)
			})
		}
		return contentOpts
	}

	const maxSelectedOptionsForMultiselect = () => {
		// check max options props
		if (maxOptions && mode === 'multiple' && input.value.length >= maxOptions) {
			// set open props for select to false,
			// when numbers of selected options is
			// higher then max selected options
			return { open: false }
		}
		return {}
	}

	return (
		<Item label={label} required={required} style={style} validateStatus={error && touched ? 'error' : undefined}>
			<Select
				{...input}
				value={input.value?.value || input.value || undefined}
				mode={mode || undefined}
				showSearch={showSearch}
				onBlur={() => {}}
				className={className || 'dropDown'}
				size={size || 'middle'}
				getPopupContainer={getPopupContainer}
				placeholder={placeholder}
				disabled={disabled}
				suffixIcon={loading ? <LoadingOutlined style={{ fontSize: 20 }} spin /> : <ChevronIcon width={20} height={20} />}
				allowClear={clearBtn}
				onChange={onChange}
				defaultValue={defaultValue}
				{...maxSelectedOptionsForMultiselect()}
			>
				{renderOptions(options)}
			</Select>
		</Item>
	)
}

export default React.memo(SelectField)
